import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Select, { components } from "react-select";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Cookies } from "../../index.js";
import { useSelector, useDispatch } from 'react-redux';
import { alert_error, alert_success } from "../../AppContext";
import Language_i18 from '../../js/useNationalLanguage.jsx';
import { Helmet } from 'react-helmet';
import Accounts_lists_vip from '../../order/account/orders/services/lists_vip.jsx';
import { update_services_categorys, update_services_orders, update_money_orders, update_category_service, update_amount_orders, update_accounts_load_show } from './actions';
localStorage.setItem("orders_reload", "YES");
function Ordergoogle({ peding_service, isOpen, isOpen2, setIsOpen, setIsOpen2, category_main, api_categorymini, servicecode, tinhgia }) {
    const { i18n, lang } = Language_i18();
    const [info_seo, set_info_seo] = useState(false);
    const [type, set_type] = useState();
    const [isDisabled, setIsDisabled] = useState(true);
    const [category_service_disabled, set_category_service_disabled] = useState(true);
    const [codeSnippet, setcodeSnippetd] = useState(`<div id="hustmedia"></div>
        <script src='https://hust.media/api/website/main.js?v=4&chedo=1'></script>`);
    const money_orders = useSelector(state => state.money_orders);
    const amount_orders = useSelector(state => state.amount_orders);
    const discount_orders = useSelector(state => state.discount_orders);
    const services_categorys = useSelector(state => state.services_categorys);
    const category_service = useSelector(state => state.category_service);
    const category_pro_lite = useSelector(state => state.category_pro_lite);
    const accounts_load_show = useSelector(state => state.accounts_load_show);

    const set_money_orders = (value) => {
        dispatch(update_money_orders(value));
    };
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { slug_1, slug_2, slug_3 } = useParams();

    const set_services_categorys = (value) => {
        dispatch(update_services_categorys(value));
    };
    const set_accounts_load_show = (value) => {
        dispatch(update_accounts_load_show(value));
    };
    const set_services_orders = (value) => {
        console.log(value);
        dispatch(update_services_orders(value));
    };
    const set_category_service = (value) => {
        dispatch(update_category_service(value));
    };
    const set_amount_orders = (value) => {
        dispatch(update_amount_orders(value));
    };
    const [categorys, set_categorys] = useState([
        {
            id: "",
            stt: "",
            name: "Please wait a moment 😊 đang tải dịch vụ",
            money: "",
            status: "show",
            content: "",
            servicecode: "",
        },
    ]);
    const handleFocus2 = () => {
        setIsOpen2(true);
        console.log(123);
    };

    const handleBlur2 = () => {
        setIsOpen2(false);
    };

    const [selectedOption, setSelectedOption] = useState(null);
    const autoSelectedServiceRef = useRef(null);

    const change_service = (event) => {
        if (!event) {
            setSelectedOption(null);
            set_services_orders({ id: "" });
            return;
        }
        setSelectedOption(event);  // Cập nhật state với mục đã chọn
        setIsOpen(false);
        const selectedOption = event.value;
        const selectedOptionok = services_categorys.find(
            (option) => option.id == selectedOption
        );
        set_services_orders(selectedOptionok);
        tinhgia(selectedOptionok);
        if (selectedOptionok.category == 'banner') {
            navigate('/shop/ads/adsprofiles');
        }
        else if (selectedOptionok.category == 'search') {
            setcodeSnippetd(`<div id="hustmedia"></div>
<script src='https://hust.media/api/website/main.js?v=4&chedo=2'></script>`);
        }
        else if (selectedOptionok.category == 'redirect') {
            setcodeSnippetd(`<div id="hustmedia"></div>
<script src='https://hust.media/api/website/main.js?v=4&chedo=1'></script>`);
        }
    };
    const handleMenuOpen2 = () => {
        setIsOpen2(true);
    };
    const handleBlur = () => {
        setIsOpen(false);
    };

    const handleMenuOpen = () => {
        setIsOpen(true);
    };
    useEffect(() => {
        if (!slug_3 || category_main) {
            if (slug_1 == 'plans') {
                reload_category(slug_2);
            }
            else if (category_main) {
                reload_category(category_main);
            }
        } else {
            const check_category_service = localStorage.getItem('category_service');
            set_category_service_disabled(
                Cookies.get("category_service_disabled") === "true"
            );
            if (slug_3 && !check_category_service) {
                reload_category(slug_3);
            } else {
                console.log(JSON.parse(localStorage.getItem('category_service') || '[]'));
                set_category_service(
                    JSON.parse(localStorage.getItem('category_service') || '[]')
                )
                set_categorys(
                    JSON.parse(localStorage.getItem('categorys') || '[]')
                )
            }
        }
    }, []);


    function reload_category(value) {
        localStorage.removeItem('category_service');
        localStorage.removeItem('category_pro_lite');
        localStorage.removeItem('category_pro_max');
        get_category_service(value);
    };

    useEffect(() => {
        if (category_pro_lite.id) {
            const orders_reload = localStorage.getItem('orders_reload');
            if (orders_reload == "YES") {
                localStorage.setItem("orders_reload", "NO");
                return;
            }
            if (category_pro_lite.code) {
                Cookies.set("category_service_disabled", false);
                get_info_category(category_pro_lite.code);
            } else if (category_pro_lite.category) {
                console.log(category_pro_lite.category);
                // set_category_pros_lite([{ id: "" }]);
                set_category_service(category_pro_lite);
                localStorage.setItem('category_service', JSON.stringify(category_pro_lite));
                Cookies.set("category_service_disabled", true);
                set_category_service_disabled(true);
                change_redirect(category_pro_lite.category);
            }
        }
        // alert_success(category_pro_lite);
    }, [category_pro_lite]);

    useEffect(() => {
        const orders_reload = localStorage.getItem('orders_reload');
        if (category_main) {
        }
        else if (orders_reload == 'YES' && !slug_3) {
        } else {
            if (category_service) {
                if (slug_3) {
                    if (category_service.category == slug_3) {
                        get_category_service(category_service.category);
                    } else {
                        if (category_service.category) {
                            reload_category(category_service.category);
                        } else {
                            reload_category(slug_3);
                        }
                    }
                }
                // alert_success(category_service);
            };
        }
    }, [category_service]);

    function get_info_category(value) {
        const apikey = Cookies.get("apikey");
        peding_service(true);
        axios
            .get("https://hust.media/getservice/category.php", {
                params: {
                    apikey: apikey,
                    option_category: value
                }
            })
            .then((response) => xuly_category(response))
            .catch((error) => alert_error(error));
    };

    function xuly_category(response) {
        set_categorys(response.data);
        localStorage.setItem('categorys', JSON.stringify(response.data));
        set_category_service_disabled(false);
        setIsOpen2(true);
        peding_service(false);
    };

    const CustomOption2 = ({ innerRef, innerProps, data }) => (
        <div ref={innerRef} {...innerProps} className="flex items-center p-2">
            {data.img && (
                <img
                    src={data.img}
                    alt={data.label}
                    className="w-7 h-7 mr-2"
                />
            )}
            <div className="text-base">{data.label}</div>
        </div>
    );

    // Component SingleValue tùy chỉnh sử dụng Tailwind CSS
    const CustomSingleValue2 = ({ innerRef, innerProps, data }) => (
        <div ref={innerRef} {...innerProps} className="flex items-center -mt-6">
            {data.img && (
                <img
                    src={data.img}
                    alt={data.label}
                    className="w-7 h-7 mr-2"
                />
            )}
            <div className="text-base">{data.label}</div>
        </div>
    );

    // Custom Option with scroll logic
    const CustomOption = ({ innerProps, data, isSelected }) => {
        const optionRef = useRef(null);

        useEffect(() => {
            if (isSelected && optionRef.current) {
                const container = optionRef.current.parentElement; // Parent element of the option
                const option = optionRef.current;

                // Calculate the scroll offset to center the option
                const containerHeight = container.clientHeight;
                const optionHeight = option.clientHeight;
                const optionTop = option.offsetTop;
                const scrollTop = container.scrollTop;

                // Calculate the center position
                const centerScrollTop = scrollTop + optionTop - (containerHeight / 2) + (optionHeight / 2);

                // Smoothly scroll to the center position
                const duration = 270; // Duration in ms
                const start = container.scrollTop;
                const distance = centerScrollTop - start;
                let startTime = null;

                const scrollStep = (timestamp) => {
                    if (!startTime) startTime = timestamp;
                    const progress = Math.min((timestamp - startTime) / duration, 1);
                    container.scrollTop = start + distance * progress;
                    if (progress < 1) {
                        requestAnimationFrame(scrollStep);
                    }
                };

                requestAnimationFrame(scrollStep);
            }
        }, [isSelected]);

        return (
            <div
                ref={optionRef}
                {...innerProps}
                className={`flex items-center p-2 ${isSelected ? 'bg-purple-300 text-white' : ''}`}
            >
                <div className="flex items-center">
                    <div className="w-7 h-5 -ml-7" />
                    <div className={`text-base text-left flex-1 ${isSelected ? '' : ''}`}>
                        <span className="text-xs">{data.value} </span>
                        {data.label} {data.money} Coins
                    </div>
                </div>
            </div>
        );
    };

    // Component SingleValue tùy chỉnh sử dụng Tailwind CSS
    const CustomSingleValue = ({ innerRef, innerProps, data }) => (
        <div ref={innerRef} {...innerProps} className="flex items-center -mt-6" >
            <div className="flex items-center">
                <div className="w-7 h-5 -ml-7" />
                <div className="text-base text-left flex-1">
                    <span className="text-xs">{data.value} </span>
                    {data.label} {data.money} Coins
                </div>
            </div>
        </div>
    );
    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#4A90E2' : state.isFocused ? '#f0f0f0' : 'white',
            color: state.isSelected ? 'white' : 'black',
            fontWeight: state.isSelected ? 'bold' : 'normal',
        }),
    };
    const change_category = (event) => {
        Cookies.set("category_service_disabled", false);
        setIsOpen2(false);
        const selectedOption = event.value;
        const selectedOptionok = categorys.find(
            (option) => option.id == selectedOption
        );
        console.log(selectedOptionok.category);
        // set_service(selectedOptionok.code);
        set_category_service(selectedOptionok);
        localStorage.setItem('category_service', JSON.stringify(selectedOptionok));
        change_redirect(selectedOptionok.category);
    };
    const change_redirect = (value) => {
        const { pathname } = location;           // ví dụ: "/posts/123/456"

        // Cách 1: dùng replace nếu chắc chắn chỉ muốn loại đúng slug_3 cuối cùng
        const baseUri = slug_3
            ? pathname.replace(`/${slug_3}`, '')  // "/posts/123"
            : pathname;                             // nếu không có slug_3 thì giữ nguyên

        // Cách 2 (dễ mở rộng nếu sau này bạn có thêm nhiều param):
        // const segments = pathname.split('/');
        // if (slug_3) segments.pop();           // loại bỏ segment cuối cùng
        // const baseUri = segments.join('/') || '/';

        const newUri = `${baseUri}/${value}`; // "/posts/123/newCategory"
        if (!slug_3) {
            window.location.href = newUri;
        } else {
            navigate(newUri);
        }
    }
    function get_category_service(value) {
        if (value === "hust_seo_media") {
            window.location.replace("/next/info/seo_media");
            return;
        }
        set_accounts_load_show(true);
        const apikey = Cookies.get("apikey");
        peding_service(true);
        axios
            .post("https://hust.media/getservice/service.php", {
                category: value,
                apikey: apikey,
                servicecode: servicecode,
                api_categorymini: api_categorymini,
                mode: "info",
                type: type
            })
            .then((response) => xuly_category_service(response))
            .catch((error) => alert_error(error));
    };
    function xuly_category_service(response) {
        set_accounts_load_show(false);
        set_services_categorys(response.data.data);
        set_info_seo(response.data.info);
        setIsDisabled(false);
        setIsOpen(true);
        peding_service(false);
    };
    const orders_service = {
        en: {
            select_category: "Select your category",
            select_service: "Select your service"
        },
        vi: {
            select_category: "Chọn chuyên mục của bạn",
            select_service: "Chọn dịch vụ của bạn"
        }
    };
    // somewhere near the top of your file, after you pull in `lang`:
    const getLocalized = content => {
        if (content == null || String(content).trim().length === 0) {
            return '';
        }
        if (typeof content === 'object') {
            return (content[lang] || content.en || '').trim();
        }
        if (typeof content === 'string') {
            try {
                const parsed = JSON.parse(content);
                if (typeof parsed === 'object') {
                    return (parsed[lang] || parsed.en || '').trim();
                }
            } catch {
                // not JSON, fall back to raw string
            }
            return content.trim();
        }
        return '';
    };

    useEffect(() => {
        if (slug_1 !== 'orders_once') {
            autoSelectedServiceRef.current = null;
            return;
        }
        if (!Array.isArray(services_categorys) || services_categorys.length === 0) return;
        if (selectedOption) return;

        const first = services_categorys[0];
        if (!first || !first.id) return;
        if (autoSelectedServiceRef.current === first.id) return;

        autoSelectedServiceRef.current = first.id;
        change_service({
            value: first.id,
            label: getLocalized(first.name),
            money: first.money,
        });
    }, [slug_1, services_categorys, selectedOption, lang]);
    const CustomMenuList = (props) => {
        const { children, selectProps } = props;
        const [filter, setFilter] = useState("");

        // ✅ ép children thành array trước khi filter
        const childrenArray = React.Children.toArray(children);

        const filteredChildren = childrenArray.filter(
            (child) =>
                child.props &&
                child.props.label &&
                child.props.label.toLowerCase().includes(filter.toLowerCase())
        );

        return (
            <components.MenuList {...props}>
                {/* ✅ chỉ hiển thị search khi số lượng item >= 10 */}
                {childrenArray.length >= 10 && (
                    <div
                        className="p-2 border-b"
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <input
                            type="text"
                            value={filter}
                            onChange={(e) => {
                                setFilter(e.target.value);
                                if (selectProps && selectProps.setIsOpen) {
                                    selectProps.setIsOpen(true);
                                }
                            }}
                            placeholder="Search..."
                            className="w-full px-2 py-1 border rounded text-sm focus:outline-none"
                            onKeyDown={(e) => {
                                if (
                                    e.key === "Backspace" ||
                                    e.key === "Delete" ||
                                    e.key === "Enter" ||
                                    e.key === "Tab"
                                ) {
                                    e.stopPropagation();
                                }
                            }}
                        />
                    </div>
                )}

                {filteredChildren.length > 0 ? (
                    filteredChildren
                ) : (
                    <div className="p-2 text-gray-500 text-sm">No results</div>
                )}
            </components.MenuList>
        );
    };

    return (
        <>

            {info_seo.keywords && (
                <Helmet>
                    {/* Title */}
                    <title>{info_seo.title}</title>

                    {/* Description */}
                    {info_seo.description && (
                        <meta name="description" content={info_seo.description} />
                    )}

                    {/* Keywords */}
                    {info_seo.keywords && (
                        <meta
                            name="keywords"
                            content={Array.isArray(info_seo.keywords)
                                ? info_seo.keywords.join(', ')
                                : info_seo.keywords}
                        />
                    )}
                </Helmet>
            )}
            {
                (slug_1 != 'plans' && !category_main) && (<>
                    <div className="text-center justify-center text-sm">{orders_service[lang]?.select_category || orders_service.en.select_category}</div>
                    <Select
                        classNamePrefix="Chọn 1 lựa chọn"
                        onFocus={handleFocus2}
                        options={categorys.map((option) => ({
                            value: option.id,
                            label: option.name,
                            img: option.img // Thêm thuộc tính img cho tùy chọn
                        }))}
                        components={{ Option: CustomOption2, SingleValue: CustomSingleValue2 }} // Sử dụng Option và SingleValue tùy chỉnh
                        menuIsOpen={isOpen2}
                        isDisabled={category_service_disabled} // Khi isDisabled là true, người dùng không thể chọn
                        onBlur={handleBlur2}
                        onMenuOpen={handleMenuOpen2}
                        value={
                            category_service.id
                                ? {
                                    value: category_service.id,
                                    label: category_service.name,
                                    img: category_service.img
                                }
                                : null
                        }
                        onChange={change_category} // Use selectedOption.value to get the selected value
                        isLoading={false}
                        isClearable={true}
                        isRtl={false}
                        isSearchable={false}
                    />
                </>)
            }
            {(slug_1 == 'product' && (slug_2 == 'play')) ? (<>
                <Accounts_lists_vip services_categorys={services_categorys} isOpen={isOpen} setIsOpen={setIsOpen} />
            </>) : (<>
                <div className="text-center justify-center text-sm">{orders_service[lang]?.select_service || orders_service.en.select_service}</div>
                <Select
                    classNamePrefix="Chọn 1 lựa chọn"
                    options={services_categorys.map(option => ({
                        value: option.id,
                        // now pick the right language, or fallback
                        label: getLocalized(option.name),
                        money: option.money,
                    }))}
                    styles={customStyles} // Áp dụng styles tùy chỉnh
                    components={{ Option: CustomOption, SingleValue: CustomSingleValue, MenuList: CustomMenuList }}
                    menuIsOpen={isOpen}
                    isDisabled={isDisabled}
                    onBlur={handleBlur}
                    onMenuOpen={() => setIsOpen(true)}
                    onMenuClose={() => setIsOpen(false)} // quan trọng: bắt sự kiện đóng
                    menuPlacement="auto" // Đặt menu để cuộn tự động
                    onChange={change_service}
                    isLoading={false}
                    isClearable={true}
                    isRtl={false}
                    isSearchable={true}
                    value={selectedOption}
                />
            </>)}
        </>
    );
}
export default Ordergoogle;
